import clsx from 'clsx';
import { motion } from 'framer-motion';
import React, { FC } from 'react';
import { BiSend } from 'react-icons/bi';

interface Props {
  disabled: boolean | undefined;
  value: string;
  onSend: () => void;
}
const SubmitButton: FC<Props> = ({ disabled, value, onSend }) => {
  return (
    <motion.button
      whileHover={!disabled && value ? { scale: 1.05 } : {}}
      whileTap={!disabled && value ? { scale: 0.95 } : {}}
      disabled={disabled || !value.trim()}
      onClick={onSend}
      className={clsx(
        'min-w-8 min-h-8 lg:min-h-10 lg:min-w-10 rounded-full flex items-center justify-center transition-colors',
        value ? 'bg-white hover:bg-white/95' : 'bg-grayZl-850',
        disabled && 'opacity-50 cursor-not-allowed',
      )}
    >
      <BiSend
        className={clsx(value ? 'text-black' : 'text-grayZl-600', 'h-5 w-5')}
      />
    </motion.button>
  );
};

export default SubmitButton;
